import { FaLightbulb, FaCode, FaServer } from 'react-icons/fa6';
import images from './images';

const pricing = [
    {
        id: 1,
        image: images.plan1,
        icon: <FaLightbulb />, // Lightbulb icon for Starter Plan
        title: 'Starter Plan',
        content: 'Perfect for Startups',
        price: 29.99,
        features: [
            'Basic AI Features',
            'Up to 10 Projects',
            'Shared Cloud Access',
            'Email Support',
        ],
    },
    {
        id: 2,
        image: images.plan2,
        icon: <FaCode />, // Code icon for Professional Plan
        title: 'Professional Plan',
        content: 'For Growing Businesses',
        price: 59.99,
        features: [
            'Advanced AI Features',
            'Up to 50 Projects',
            'Dedicated Cloud Resources',
            'Priority Support',
        ],
    },
    {
        id: 3,
        image: images.plan3,
        icon: <FaServer />, // Server icon for Enterprise Plan
        title: 'Enterprise Plan',
        content: 'Ultimate Enterprise Solution',
        price: 129.99,
        features: [
            'Full Suite of AI Features',
            'Unlimited Projects',
            'Private Cloud Hosting',
            '24/7 Dedicated Support',
        ],
    },
];

export default pricing;